import notImplemented from "./not_implemented_extension";
export default function (scheduler) {
  notImplemented.alert("Tree Timeline", scheduler.assert);
}